import React from "react";

import { Icon } from "@metrea-ui/v2";
import styles from "./BorderedSection.module.css";

function BorderedSection({ icon, title, children, showHeader = true, containerStyle }) {
	return (
		<div
			className={styles.mainContainer}
			style={
				showHeader
					? containerStyle
					: {
							borderTop: "1px solid var(--border-color)",
							...containerStyle,
						}
			}
		>
			{showHeader ? (
				<div className={styles.header}>
					<div className={styles.headerBorderBefore}></div>
					{(icon || title) && (
						<div className={styles.headerTitle}>
							{icon && <Icon as={icon} />}
							{title && <span className={styles.title}>{title}</span>}
						</div>
					)}
					<div className={styles.headerBorderAfter}></div>
				</div>
			) : null}
			<div className={styles.childrenContainer}>{children}</div>
		</div>
	);
}

export default BorderedSection;
